import { useMemo } from "react";
import { useParams } from "react-router-dom";

export function useReactRoute() {
  const params = useParams();
  return useMemo(() => Object.freeze({ params: Object.freeze({ ...params }) }), [params]);
}
